import React from 'react';
import { useTranslation } from 'react-i18next';

import './PowerUpTitle.css';

const PowerUpTitle = ({
  children,
  id = '',
  title,
}) => {
  const { t } = useTranslation('quoting');
  return (
    <div className="Powerup-title-container-optional">
      <div className="Powerup-title">
        <h3 id={id}>
          <span className="Powerup-optional">
            {t('powerUpsSection.optional')}
          </span>

          {title}
        </h3>

        {children}
      </div>
    </div>
  );
};

export { PowerUpTitle };
